export enum RoleType {
    VueJs = 'vue_js',
    Flutter = 'flutter',
    Laravel = 'laravel',
    MiniProgram = 'mini_program',
    ProjectManager = 'project_manager',
}
